let router = [
    {
        path: '/integral/product',
        name: 'list',
        component: () => import('@/views/integral/product/list.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/product/edit',
        name: 'edit',
        component: () => import('@/views/integral/product/edit.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/classify',
        name: 'classify',
        component: () => import('@/views/integral/classify.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    }
    ,  
    {
        path: '/integral/tasks',
        name: 'taskslist',
        component: () => import('@/views/integral/tasks/list.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/tasks/edit',
        name: 'tasksedit',
        component: () => import('@/views/integral/tasks/edit.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/config',
        name: 'integralconfig',
        component: () => import('@/views/integral/config.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    }
    ,  
    {
        path: '/integral/order',
        name: 'orderlist',
        component: () => import('@/views/integral/order/list.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/order/edit',
        name: 'orderedit',
        component: () => import('@/views/integral/order/edit.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    },
    {
        path: '/integral/record',
        name: 'integralrecord',
        component: () => import('@/views/integral/record.vue'),
        meta: {keepAlive: true, parentPath: 'integral'},
    }
    
    
]
export default router


// WEBPACK FOOTER //
// ./src/router/integral.js